import { __decorate } from "tslib";
//NPM
import { Component, Mixins } from "vue-property-decorator";
import * as _ from "lodash";
import { interpret } from "xstate";
import simplebar from "simplebar-vue";
//PALMATE
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import Loader from "@/components/widgets/loader.vue";
import BaseMixer from "@/router/views/BaseMixer";
import PageManagerMachine from "./machines/PageManagerMachine";
import PageUpsertComponent from "./components/PageUpsertComponent.vue";
import PageElementUpsertComponent from "./components/PageElementUpsertComponent.vue";
import { PageElementModel, PageManagerModel } from "@/store/models/pageManager/PageManager";
import { PageManagerModule } from "@/store/modules/PageManager.module";
import DeleteComponent from "@/components/deleteComponent.vue";
let PageManager = /** @class */ (() => {
    let PageManager = class PageManager extends Mixins(BaseMixer) {
        constructor() {
            // DATA
            super(...arguments);
            this.title = "Page Manager";
            this.items = [
                {
                    text: "Home",
                    to: "/dashBoard",
                },
                {
                    text: "Developer Tools",
                    href: "#",
                },
                {
                    text: "Page Manager",
                    active: true,
                },
            ];
            this.searchKey = "";
            // --> Pointer
            this.newListMaster = null;
            this.selectedListId = "";
            this.pageElementId = "";
            this.pageId = "";
            this.newPage = null;
            this.listUnderEdit = null;
            this.newPageElement = null;
            this.pageElementUnderEdit = null;
            // MACHINE
            this.machine = PageManagerMachine;
            this.machineService = interpret(this.machine, { devTools: true });
            this.state = this.machine.initialState;
        }
        // METHODS
        send(event) {
            this.machineService.send(event);
        }
        getPageName() {
            return this.Pages.find((x) => x.id == this.selectedListId).text;
        }
        selectPage(listId) {
            this.selectedListId = listId;
            this.send({ type: "LOAD_PAGEELEMENTS", pageId: this.selectedListId });
        }
        addNewPage() {
            this.newPage = new PageManagerModel();
            this.newPage.displayOrder = this.sortedFilteredPage.length + 1;
            this.send({ type: "ADDING_PAGE" });
        }
        savePage() {
            var rootElement = new PageElementModel();
            rootElement.text = "Basic Privilege";
            rootElement.description = "This is the ".concat(this.newPage.text).concat(" root Element");
            rootElement.isRoot = true;
            rootElement.displayOrder = 1;
            this.newPage.children = [];
            this.newPage.children.push(rootElement);
            this.send({ type: "SAVE_PAGE", newPage: this.newPage });
        }
        editPage(list) {
            this.listUnderEdit = Object.assign({}, list);
            this.send({ type: "EDIT_PAGE" });
        }
        deletePage(list) {
            this.pageId = list.id;
            this.send({ type: "DELETE_PAGE" });
        }
        deletingPage() {
            this.send({ type: "DELETING_PAGE", pageId: this.pageId });
        }
        cancelPage() {
            (this.pageId = ""), this.send({ type: "CANCEL_DELETE_PAGE" });
        }
        amIaPageUnderEdit(list) {
            if (this.listUnderEdit != null) {
                return this.listUnderEdit.id == list.id;
            }
            return false;
        }
        updatePage() {
            this.send({ type: "UPDATE_PAGE", updatePage: this.listUnderEdit });
        }
        addPageElement() {
            this.newPageElement = new PageElementModel();
            this.newPageElement.displayOrder = this.sortedPageElement.length + 1;
            this.send({ type: "ADDING_PAGE_ELEMENT" });
        }
        savePageElement() {
            this.newPageElement.pageId = this.selectedListId;
            this.send({
                type: "SAVING_PAGE_ELEMENT",
                newPageElement: this.newPageElement,
            });
        }
        editPageElement(item) {
            this.pageElementUnderEdit = Object.assign({}, item);
            this.send({ type: "EDITING_PAGE_ELEMENT" });
        }
        deletePageElement(item) {
            this.pageElementId = item.id;
            this.send({ type: "DELETE_PAGE_ELEMENT" });
        }
        deletingPageElement() {
            this.send({
                type: "DELETING_PAGE_ELEMENT",
                pageElementId: this.pageElementId,
            });
        }
        cancelPageElement() {
            (this.pageElementId = ""), this.send({ type: "CANCEL_DELETE_PAGE_ELEMENT" });
        }
        amIaPageElementUnderEdit(item) {
            if (this.pageElementUnderEdit != null) {
                return this.pageElementUnderEdit.id == item.id;
            }
            return false;
        }
        updatePageElement() {
            this.send({
                type: "UPDATE_PAGE_ELEMENT",
                updatePageElement: this.pageElementUnderEdit,
            });
        }
        get Pages() {
            return _.sortBy(PageManagerModule.pages, (item) => item.text);
        }
        get listItems() {
            return _.sortBy(PageManagerModule.pageElements, (item) => item.text);
        }
        get filteredPage() {
            if (this.searchKey != "") {
                return PageManagerModule.pages.filter((x) => x.text.toLowerCase().indexOf(this.searchKey.toLowerCase()) > -1);
            }
            return PageManagerModule.pages;
        }
        get sortedFilteredPage() {
            return _.sortBy(this.filteredPage, (o) => o.text);
        }
        get filteredPageElement() {
            return PageManagerModule.pageElements;
        }
        get sortedPageElement() {
            return _.sortBy(this.filteredPageElement, (o) => o.displayOrder);
        }
        created() {
            this.machineService.onTransition((state) => {
                this.state = state;
                if (state.matches("loadedPages")) {
                    this.listUnderEdit = null;
                    //this.selectPage(this.Pages[0].id);
                }
                if (state.matches("loadedPageElements.listing")) {
                    this.pageElementUnderEdit = null;
                }
            });
            this.machineService.start();
        }
        destroyed() {
            this.machineService.stop();
        }
    };
    PageManager = __decorate([
        Component({
            name: "PageManager",
            components: {
                Layout,
                PageHeader,
                Loader,
                simplebar,
                PageUpsertComponent,
                PageElementUpsertComponent,
                DeleteComponent,
            },
        })
    ], PageManager);
    return PageManager;
})();
export default PageManager;
